import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http'; // 🚀 INYECTADO: withInterceptors
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { routes } from './app.routes';
import { tenantInterceptor } from './guards/tenant-interceptor'; // 🚀 Tu nuevo interceptor funcional

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes), 
    provideClientHydration(withEventReplay()),
    
    // =========================================================================
    // 🛡️ ENGRANAJE SAAS CORE: ACOPLAMIENTO DE INTERCEPTOR SOBRE ENGINE FETCH
    // =========================================================================
    // Conservamos tu motor con 'withFetch()' para un performance extraordinario
    // e inyectamos tu aduana perimetral de red en el mismo canal.
    provideHttpClient(
      withFetch(),
      withInterceptors([tenantInterceptor]) // Habilita el pegado automático de la cabecera 'X-Company-ID'
    ),
  ]
};